// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxInput_wrapper__hfp1H","circle":"CheckboxInput_circle__PG-Z-"};